import { IntegrationInitializationModal } from '../IntegrationInitializationModal'

import { useModals } from 'almanac-ui/Modal'
import { YouTube } from 'blaze-ui/icons'

import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { IntegrationNotice } from '../IntegrationNotice'
import Styles from '../IntegrationInitializationModal.module.scss'

// TODO: set real connection guide link for YouTube with BLZ-3298
export const YoutubeNotice = () => (
  <IntegrationNotice
    // connectionGuideLink="https://help.blaze.ai/en/articles/9556524-connect-blaze-to-youtube-channel"
    message={
      <div className={Styles.message}>
        YouTube requires a Google account to authenticate and that Google account must be the owner of the YouTube
        channel you want to connect or the admin of the YouTube Brand Account.
        {/* <div className={Styles.note}>If you are not sure if you have the right setup, review our guide:</div> */}
      </div>
    }
  />
)

const YouTubeInitialization = ({ userIsAttemptingToPost = false, useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const title = userIsAttemptingToPost ? 'Set up your YouTube integration' : 'Connect YouTube Account'

  const handleConfirm = () => {
    initiateOauth(ExternalIntegrationEnum.YouTube)
  }

  const sharedProps = {
    notice: <YoutubeNotice />,
    providerName: 'YouTube',
    onClose: closeModal,
    icon: <YouTube size={32} />,
    title: title,
    onConfirm: handleConfirm,
    primaryButtonText: 'Go to YouTube',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default YouTubeInitialization
